import React, { useState } from 'react';
import BinarySearchControls from './components/BinarySearchControls';
import MergeSortControls from './components/MergeSortControls';
import QuickSortControls from './components/QuickSortControls'; 
import DijkstraControls from './components/DijkstraControls';
import BinarySearchVisualizer from './components/BinarySearchVisualizer';
import MergeSortVisualizer from './components/MergeSortVisualizer';
import QuickSortVisualizer from './components/QuickSortVisualizer';
import DijkstraVisualizer from './components/DijkstraVisualizer';
import './styles.css';

function App() {
  const [array, setArray] = useState([]);
  const [target, setTarget] = useState(null);
  const [graph, setGraph] = useState({ nodes: [], edges: [] });
  const [algorithm, setAlgorithm] = useState('binary-search');

  const handleStart = (inputArray, searchElement) => {
    setArray(inputArray);
    setTarget(searchElement);
  };

  const handleDijkstraStart = (inputGraph) => {
    setGraph(inputGraph);
  };

  const handleAlgorithmChange = (e) => {
    const selectedAlgorithm = e.target.value;
    setAlgorithm(selectedAlgorithm);
    setArray([]);
    setTarget(null);
    setGraph({ nodes: [], edges: [] });
  };

  return (
    <div className="App">
      <div className="algorithm-selector">
        <label>
          Select Algorithm:
          <select value={algorithm} onChange={handleAlgorithmChange}>
            <option value="binary-search">Binary Search</option>
            <option value="merge-sort">Merge Sort</option>
            <option value="quick-sort">Quick Sort</option>
            <option value="dijkstra">Dijkstra Algorithm</option>
          </select>
        </label>
      </div>
      {algorithm === 'binary-search' ? (
        <BinarySearchControls onStart={handleStart} />
      ) : algorithm === 'merge-sort' ? (
        <MergeSortControls onStart={handleStart} />
      ) : algorithm === 'quick-sort' ? (
        <QuickSortControls onStart={handleStart} />
      ) : (
        <DijkstraControls onStart={handleDijkstraStart} />
      )}
      {array.length > 0 && algorithm === 'binary-search' && target != null && (
        <BinarySearchVisualizer array={array} target={target} />
      )}
      {array.length > 0 && algorithm === 'merge-sort' && (
        <MergeSortVisualizer array={array} />
      )}
      {array.length > 0 && algorithm === 'quick-sort' && (
        <QuickSortVisualizer array={array} />
      )}
      {graph.nodes.length > 0 && algorithm === 'dijkstra' && (
        <DijkstraVisualizer graph={graph} />
      )}
    </div>
  );
}

export default App;
